<template>
  <div class="vz-title-play">
    <template v-if="ppc === 1">
      <span class="vz-bts-warning">Conteúdo não disponível no seu plano</span>

      <vz-button
        class="vz-bt-plan vz-primary"
        ariaLabel="Alterar plano"
        @click="emitEvent('change-plan')"
      >
        <span class="vz-bt-plan-label">Deseja altera seu plano?</span>
      </vz-button>
    </template>

    <vz-button
      class="vz-bt-play vz-primary"
      v-if="ppc === 2 && contentType !== 'MODULE' && contentType !== 'COURSE'"
      ariaLabel="Assistir"
      @click="emitEvent('play')"
    >
      <i class="ic-play-circle vz-bt-play-ic"></i>
      <span class="vz-bt-play-label">Assistir</span>
    </vz-button>

    <template v-else-if="ppc === 3">
      <span class="vz-bts-warning">
        O pagamento dos seus serviços está pendente. Acesse sua conta e efetue o
        pagamento.
      </span>

      <vz-button
        ariaLabel="Acessar minha conta"
        class="vz-bt-account vz-primary"
        @click="emitEvent('account')"
      >
        <span class="vz-bt-account-label">Acessar minha conta</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 4">
      <span class="vz-bts-warning">Conteúdo não disponível no seu plano</span>

      <vz-button
        class="vz-bt-plan vz-primary"
        @click="emitEvent('change-plan')"
        ariaLabel="Alterar plano"
      >
        <span class="vz-bt-plan-label">Deseja alterar seu plano?</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 5">
      <span class="vz-bts-warning">
        Alugar por
        <span class="vz-rent-price">{{ rentPrice }}</span>
      </span>

      <vz-button
        class="vz-bt-rent vz-primary"
        :loading="status === 'loading' || status === 'renting'"
        ariaLabel="Alugar"
        @click="emitEvent('rent')"
      >
        <i class="ic-coin vz-bt-rent-ic"></i>
        <span class="vz-bt-rent-label">Alugar</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 6">
      <span class="vz-bts-warning"
        >Você precisa cadastrar um método de pagamento</span
      >

      <vz-button
        class="vz-bt-account vz-primary"
        @click="emitEvent('complete-profile')"
        ariaLabel="Completar cadastro"
      >
        <span class="vz-bt-account-label"
          >Para prosseguir complete o seu cadastro</span
        >
      </vz-button>
    </template>

    <template v-else-if="ppc === 7">
      <span class="vz-bts-warning"
        >Você precisa se cadastrar para ter acesso a este conteúdo.</span
      >

      <vz-button
        class="vz-bt-signup vz-primary"
        ariaLabel="Fazer cadastro"
        @click="emitEvent('create-account')"
      >
        <span class="vz-bt-signup-label">Fazer meu cadastro</span>
      </vz-button>
    </template>

    <span class="vz-bts-warning" v-else-if="ppc === 8">
      Este conteúdo não está disponível. Para mais informações, entre em contato
      com nosso suporte.
    </span>

    <template v-else-if="ppc === 9">
      <div class="ppc9">
        <span class="vz-bts-warning">
          Este conteúdo não está no seu plano, gostaria de assistir agora?
        </span>

        <vz-button
          class="vz-bt-play vz-primary"
          v-if="isShowcase"
          ariaLabel="Adquirir"
          @click="emitEvent('click')"
        >
          <i class="ic-coin vz-bt-rent-ic"></i>
          <span class="vz-bt-play-label">Adquira</span>
        </vz-button>

        <title-actions-button
          v-if="!isShowcase"
          @click="emitEvent('click')"
          :actions="actionsForPPC9"
          openActionsLabel="Quero assistir agora"
        >
        </title-actions-button>
      </div>
    </template>

    <template v-else-if="contentType == 'LESSON' && ppc === 10">
      <vz-button
        disabled
        class="vz-bt-plan vz-primary"
        ariaLabel="Conteúdo começará em breve"
      >
        <span class="vz-bt-plan-label">Esse curso começará em breve</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 10">
      <span class="vz-bts-warning">Conteúdo adquirido</span>

      <vz-button disabled class="vz-bt-plan vz-primary">
        <span class="vz-bt-plan-label">Data de início: {{ startDate }}</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 11">
      <span class="vz-bts-warning vz-bts-warning-ppc-11">
        <div class="vz-bts-warning-info">
          <span class="vz-bts-warning-info-label">Vagas restantes</span>
          <span>{{ remainingVacancies }}</span>
        </div>

        <div class="vz-bts-warning-info">
          <span class="vz-bts-warning-info-label">Inscrições até</span>
          <span>{{ subscribeUntil }}</span>
        </div>

        <div class="vz-bts-warning-info">
          <span class="vz-bts-warning-info-label">Preço</span>
          <span>{{ rentPrice }}</span>
        </div>
      </span>

      <vz-button
        class="vz-bt-rent vz-primary"
        :loading="status === 'loading' || status === 'renting'"
        @click="emitEvent('rent')"
        ariaLabel="Quero participar"
      >
        <span class="vz-bt-rent-label">Quero participar</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 12">
      <vz-button disabled class="vz-bt-plan vz-primary">
        <span class="vz-bt-plan-label">Não há turmas disponíveis</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 13">
      <vz-button disabled class="vz-bt-plan vz-primary">
        <span class="vz-bt-plan-label">Não há vagas abertas</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 14">
      <vz-button disabled class="vz-bt-plan vz-primary">
        <span class="vz-bt-plan-label"
          >Assista o conteúdo anterior para desbloquear</span
        >
      </vz-button>
    </template>

    <template v-else-if="ppc === 15">
      <vz-button
        class="vz-bt-plan vz-primary"
        ariaLabel="Ingressar"
        @click="joinClassroom"
      >
        <span class="vz-bt-play-label">Ingressar</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 16">
      <vz-button disabled class="vz-bt-play vz-primary finished-course-bt">
        <span class="vz-bt-play-label">Você já finalizou esse curso</span>
      </vz-button>
    </template>

    <template v-else-if="ppc === 17">
      <span class="vz-bts-warning"
        >Para liberar este conteúdo, você primeiro deve assistir o conteúdo
        abaixo:</span
      >

      <vz-button disabled class="vz-bt-play vz-primary">
        <strong>{{ predecessorName }}</strong>
      </vz-button>
    </template>

    <vz-button
      v-else-if="ppc === 18"
      class="vz-bt-play vz-primary"
      ariaLabel="Conteúdo bloqueado"
    >
      <i class="ic-lock vz-bt-lock-ic"></i>
    </vz-button>
  </div>
</template>

<script>
import VzButton from 'vsp-web-ui-lib/components/atoms/vz-button.vue';
import dayjs from 'dayjs';
import TitleActionsButton from './title-actions-button.vue';
import VzModal from '../molecules/vz-modal.vue';
import Formatter from '../../libs/formats';

export default {
  name: 'TitlePlayButton',

  emits: [
    'play',
    'account',
    'change-plan',
    'rent',
    'create-account',
    'complete-profile',
    'click',
    'joinClassroom'
  ],

  components: {
    VzButton,
    TitleActionsButton,
    VzModal
  },

  props: {
    ppc: {
      type: Number,
      default: 2
    },
    predecessorName: {
      type: String,
      default: null
    },
    classroom: {
      type: Object,
      default: () => ({})
    },
    contentType: {
      type: String,
      default: '',
      required: false
    },
    isSeries: {
      type: Boolean,
      default: false
    },
    isShowcase: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'idle'
    },
    price: {
      type: Number,
      default: 0
    }
  },

  computed: {
    actionsForPPC9() {
      return [
        {
          label: 'Quero trocar meu plano',
          value: () => {
            this.emitEvent('change-plan');
          },
          icon: 'ic-repeat'
        },
        {
          label: `Alugar por ${Formatter.formatCurrency(this.price)}`,
          value: () => {
            this.emitEvent('rent');
          },
          icon: 'ic-coin vz-bt-rent-ic'
        }
      ];
    },
    rentPrice() {
      return Formatter.formatCurrency(this.price);
    },
    startDate() {
      const date = dayjs(new Date(this.classroom?.startDate)).format(
        'DD/MM/YYYY'
      );

      return date;
    },
    remainingVacancies() {
      return this.classroom.maxUsers - this.classroom.registeredUsers;
    },
    subscribeUntil() {
      const date = new Date(this.classroom.startDate);
      date.setMinutes(date.getMinutes() - 1);

      const subscribeUntil = dayjs(date).format('DD/MM/YYYY');

      return subscribeUntil;
    }
  },

  data: () => ({
    showModal: false
  }),

  methods: {
    emitEvent(event) {
      this.$emit('click');

      if (event !== 'click') this.$emit(event);
    },

    joinClassroom() {
      const endDate = dayjs(new Date(this.classroom?.endDate)).format(
        'DD/MM/YYYY'
      );

      this.$store
        .dispatch('ui/showConfirmation', {
          title: 'Deseja ingressar no curso nesse momento?',
          text: `Ao ingressar, você deverá concluir o curso até o dia ${endDate}`,
          buttons: [
            { primary: true, value: true, label: 'Ingressar' },
            { primary: false, value: false, label: 'Cancelar' }
          ]
        })
        .then((hasConfirmation) => {
          if (!hasConfirmation) {
            return;
          }

          this.$api.content
            .joinCourseClass({
              videoId: this.$store.state.content.current.info.id,
              utoken: this.$store.state.user.session.token
            })
            .then(() => {
              window.location.reload();
            });
        });
    }
  }
};
</script>





























































































































































<style theme="light-theater" scoped>
.vz-bt-play,
.vz-bt-account,
.vz-bt-plan,
.vz-bt-rent,
.vz-bt-signup {
  width: 100%;
  padding: 14px 16px;
}

.vz-list-item-play .vz-bts-warning,
.vz-title-featured-play .vz-bts-warning,
.vz-list-item-play .vz-bt-play-label,
.vz-list-item-play .vz-bt-rent-label,
.vz-list-item-play .vz-bt-account,
.vz-title-featured-play .vz-bt-account,
.vz-list-item-play .vz-bt-plan,
.vz-title-featured-play .vz-bt-plan,
.vz-list-item-play .vz-bt-signup,
.vz-title-featured-play .vz-bt-signup,
.vz-list-item .ppc9,
.vz-featured-list-item .ppc9 {
  display: none;
}

.vz-list-item-play .vz-bt-play,
.vz-list-item-play .vz-bt-rent,
.vz-layout .vz-list-item-play .vz-bt-play,
.vz-layout .vz-list-item-play .vz-bt-rent {
  background-color: transparent;
  box-shadow: none;
  border-width: 0;
  padding: 0;
}

.vz-title-featured-play .vz-bt-play,
.vz-title-featured-play .vz-bt-rent {
  padding: 8px 12px 9px;
  margin-right: 8px;
  width: auto;
}

.finished-course-bt {
  padding: 12px;
}

.vz-bt-play-ic,
.vz-bt-rent-ic {
  font-size: 1.2em;
  vertical-align: text-top;
  display: inline-block;
  margin-right: 4px;
}

.vz-list-item-play .vz-bt-play-ic,
.vz-list-item-play .vz-bt-rent-ic,
.vz-list-item-play .vz-bt-lock-ic {
  transition-property: color, border-color;
  transition-duration: 0.3s;
  margin: 0;
}

.vz-list-item-play .vz-bt-play-ic,
.vz-list-item-play .vz-bt-rent-ic {
  font-size: 40px;
}

.vz-list-item-play .vz-bt-play:hover .vz-bt-play-ic,
.vz-list-item-play .vz-bt-rent:hover .vz-bt-rent-ic,
.vz-list-item-play .vz-bt-play:hover .vz-bt-lock-ic {
  color: var(--primary-color-over);
}

.vz-list-item-play .vz-bt-play:active .vz-bt-play-ic,
.vz-list-item-play .vz-bt-rent:active .vz-bt-rent-ic,
.vz-list-item-play .vz-bt-play:active .vz-bt-lock-ic {
  color: var(--primary-color-active);
}

.vz-title-featured-play .vz-bt-play-ic,
.vz-title-featured-play .vz-bt-rent-ic {
  font-size: 20px;
  vertical-align: sub;
}

.vz-bts-warning {
  text-align: center;
  font-size: 0.875em;
  padding: 8px 16px;
  display: block;
  width: 100%;
  background-color: rgba(28, 28, 28, 0.15);
}

.vz-bts-warning-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vz-bts-warning-info-label {
  color: var(--primary-color);
}

.vz-bts-warning-ppc-11 {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding-left: 0;
  padding-right: 0;
}

@media (min-width: 1024px) {
  .vz-title-featured-play .vz-bt-play,
  .vz-title-featured-play .vz-bt-rent {
    margin: 0 24px 24px 0;
    padding: 14px 20px;
  }

  .finished-course-bt {
    padding: 14px 20px;
  }
}

@media only screen and (max-width: 600px) {
  .ppc9 .vz-bt-plan,
  .ppc9 .vz-bt-rent {
    font-size: 0.74em;
  }
}

.vz-title-featured-actions .ppc9 .vz-bt-rent {
  margin: 0 24px 24px 0;
  width: auto;
}

.vz-title-featured-actions .ppc9 .vz-bt-rent .vz-rent-price {
  display: none;
}

.ppc9 {
  text-align: center;
  width: 100%;
  display: inline-table;
}

.ppc9 .vz-bt-plan {
  width: 49.4%;
  margin-right: 1px;
}

.ppc9 .vz-bt-rent {
  width: 49.4%;
  margin-left: 1px;
}
</style>
